import React, { useEffect } from 'react'

import { Heading, theme, ImageWrap } from '@hhgtech/hhg-components'
import { Container } from 'components/atoms/container'
import { domainLocales } from 'domainLocales'
import { Article } from 'interfaces/types'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { useIntl } from 'react-intl'
import Skeleton from 'react-loading-skeleton'
import { lazyLoadInstance } from 'utils/lazyLoad'

import { DEFAULT_IMG } from '../../../interfaces/constants'
import { ArticleCardWrapper } from '../../molecules/articleCardWrapper/index'
import {
  StyleFeaturedTopics,
  StyledFeatureSmallArticleContainer,
  StyledFeatureTopicSeeMore,
  StyledHeroContainer,
  StyledArticlesDesktopContainer,
  StyledArticleContainer,
  StyledHeaderContainer,
  StyledSmallArticleDesktopContainer,
  StyledSubColumnContainer,
  StyledArticlesContainer,
  StyledContainer,
} from './index.styled'

export type Props = {
  isLoading?: boolean
  seeMoreLink?: string
  onArticleClick?: (l: string) => void
  expertsArticles?: Article[]
  isMobile?: boolean
  hideUIElements?: boolean
  isPadding?: boolean
}

const ToolsSuggestionArticles = ({
  isMobile,
  expertsArticles: articles = [],
  isLoading = false,
  hideUIElements,
  seeMoreLink,
  isPadding,
}: // onArticleClick,
Props) => {
  const { formatMessage: f } = useIntl()
  const router = useRouter()
  const { locale } = router
  const sL = locale || 'vi-VN' // standardized locale
  const ArticlesSkeleton = () => {
    return isMobile ? (
      <>
        <StyledContainer>
          <StyledArticleContainer>
            <Container>
              <StyledArticleContainer>
                <Skeleton height={192} />
                <Skeleton
                  height={20}
                  width="60%"
                  style={{
                    marginTop: '8px',
                  }}
                />
                <Skeleton
                  height={30}
                  width="100%"
                  style={{
                    marginTop: '8px',
                  }}
                />
                <Skeleton
                  height={60}
                  width="100%"
                  style={{
                    marginTop: '8px',
                  }}
                />
                <Skeleton
                  height={20}
                  width="80%"
                  style={{
                    marginTop: '8px',
                  }}
                />
              </StyledArticleContainer>
            </Container>
          </StyledArticleContainer>
          <StyledArticleContainer>
            <Container>
              <StyledArticleContainer>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                  }}
                >
                  <span>
                    <Skeleton height={100} width={100} />
                  </span>
                  <span
                    style={{
                      marginLeft: '16px',
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    <Skeleton height={20} width="30%" />
                    <Skeleton
                      height={20}
                      width="50%"
                      style={{
                        marginTop: '8px',
                      }}
                    />
                    <Skeleton
                      height={40}
                      width="100%"
                      style={{
                        marginTop: '8px',
                      }}
                    />
                  </span>
                </div>
              </StyledArticleContainer>
            </Container>
          </StyledArticleContainer>
          <StyledArticleContainer>
            <Container>
              <StyledArticleContainer>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                  }}
                >
                  <span>
                    <Skeleton height={100} width={100} />
                  </span>
                  <span
                    style={{
                      marginLeft: '16px',
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    <Skeleton height={20} width="30%" />
                    <Skeleton
                      height={20}
                      width="50%"
                      style={{
                        marginTop: '8px',
                      }}
                    />
                    <Skeleton
                      height={40}
                      width="100%"
                      style={{
                        marginTop: '8px',
                      }}
                    />
                  </span>
                </div>
              </StyledArticleContainer>
            </Container>
          </StyledArticleContainer>
          <StyledArticleContainer>
            <Container>
              <StyledArticleContainer>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                  }}
                >
                  <span>
                    <Skeleton height={100} width={100} />
                  </span>
                  <span
                    style={{
                      marginLeft: '16px',
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    <Skeleton height={20} width="30%" />
                    <Skeleton
                      height={20}
                      width="50%"
                      style={{
                        marginTop: '8px',
                      }}
                    />
                    <Skeleton
                      height={40}
                      width="100%"
                      style={{
                        marginTop: '8px',
                      }}
                    />
                  </span>
                </div>
              </StyledArticleContainer>
            </Container>
          </StyledArticleContainer>
        </StyledContainer>
      </>
    ) : (
      <>
        <StyledHeroContainer>
          <div
            style={{
              display: 'flex',
              width: '100%',
              flexDirection: 'column',
            }}
          >
            <Skeleton height={312} />
            <Skeleton
              height={20}
              width="60%"
              style={{
                marginTop: '8px',
              }}
            />
            <Skeleton
              height={30}
              width="100%"
              style={{
                marginTop: '8px',
              }}
            />
            <Skeleton
              height={60}
              width="100%"
              style={{
                marginTop: '8px',
              }}
            />
            <Skeleton
              height={20}
              width="80%"
              style={{
                marginTop: '8px',
              }}
            />
          </div>
        </StyledHeroContainer>
        <StyledSubColumnContainer>
          <StyledArticleContainer>
            <div
              style={{
                display: 'flex',
                alignItems: 'flex-start',
              }}
            >
              <span>
                <Skeleton height={100} width={100} />
              </span>
              <span
                style={{
                  marginLeft: '16px',
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <Skeleton height={20} width="30%" />
                <Skeleton
                  height={20}
                  width="50%"
                  style={{
                    marginTop: '8px',
                  }}
                />
                <Skeleton
                  height={40}
                  width="100%"
                  style={{
                    marginTop: '8px',
                  }}
                />
              </span>
            </div>
          </StyledArticleContainer>
          <StyledArticleContainer>
            <div
              style={{
                display: 'flex',
                alignItems: 'flex-start',
              }}
            >
              <span>
                <Skeleton height={100} width={100} />
              </span>
              <span
                style={{
                  marginLeft: '16px',
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <Skeleton height={20} width="30%" />
                <Skeleton
                  height={20}
                  width="50%"
                  style={{
                    marginTop: '8px',
                  }}
                />
                <Skeleton
                  height={40}
                  width="100%"
                  style={{
                    marginTop: '8px',
                  }}
                />
              </span>
            </div>
          </StyledArticleContainer>
          <StyledArticleContainer>
            <div
              style={{
                display: 'flex',
                alignItems: 'flex-start',
              }}
            >
              <span>
                <Skeleton height={100} width={100} />
              </span>
              <span
                style={{
                  marginLeft: '16px',
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <Skeleton height={20} width="30%" />
                <Skeleton
                  height={20}
                  width="50%"
                  style={{
                    marginTop: '8px',
                  }}
                />
                <Skeleton
                  height={40}
                  width="100%"
                  style={{
                    marginTop: '8px',
                  }}
                />
              </span>
            </div>
          </StyledArticleContainer>
        </StyledSubColumnContainer>
      </>
    )
  }

  useEffect(() => {
    if (lazyLoadInstance) {
      lazyLoadInstance.update()
    }
  }, [])

  return (
    <>
      {isMobile ? (
        <StyleFeaturedTopics data-is-padding={isPadding}>
          {!hideUIElements && (
            <Heading tag="h3" color={theme.colors.gray800}>
              {f({
                id: 'tools.suggestedArticles',
                defaultMessage: 'Suggested articles',
              })}
            </Heading>
          )}
          {isLoading ? (
            <ArticlesSkeleton />
          ) : (
            <StyledContainer>
              {articles && articles.length > 0 && (
                <>
                  <StyledArticleContainer className="article-container">
                    <Container>
                      <ArticleCardWrapper
                        article={articles[0]}
                        dataEventCategoryForCategory="Tools Category Title"
                        dataEventActionForCategory="Click"
                        dataEventLabelForCategory={`https://${domainLocales[sL]}${articles[0].category.permalink}`}
                        dataEventCategoryForTitle="Tool Title"
                        dataEventActionForTitle="Click"
                        dataEventLabelForTitle={`https://${domainLocales[sL]}${articles[0].permalink}`}
                        dataEventCategoryForBanner="Tool Image"
                        dataEventActionForBanner="Click"
                        dataEventLabelForBanner={`https://${domainLocales[sL]}${articles[0].permalink}`}
                        size="lg"
                        type="author"
                        direction="vertical"
                        banner={
                          <ImageWrap
                            src={
                              articles[0].featureImageMobile ||
                              articles[0].featureImage ||
                              DEFAULT_IMG
                            }
                            loading="lazy"
                            style={{
                              objectFit: 'cover',
                              width: '100%',
                              height: '100%',
                            }}
                            alt={articles[0].postTitle || articles[0].postName}
                          />
                        }
                        isMobile={isMobile}
                        articleLink={articles[0].permalink}
                        specialty={articles[0].expert.specialty}
                        avatarImgRenderer={(avatar, name) => (
                          <ImageWrap
                            src={avatar || '/images/avatar.jpg'}
                            style={{ width: '100%', height: '100%' }}
                            alt={name}
                            loading="lazy"
                          />
                        )}
                        categoryLink={articles[0].category.permalink}
                        categoryName={articles[0].category?.displayName}
                        title={articles[0].postTitle || articles[0].postName}
                        text={''}
                        styleLabel={{
                          color: articles[0].category.textColor,
                        }}
                        uploadTime={articles[0].modifiedTime}
                        headingType="h4"
                      />
                    </Container>
                  </StyledArticleContainer>
                  <StyledArticlesContainer>
                    {articles.slice(1, 3).map((article: Article) => (
                      <StyledFeatureSmallArticleContainer
                        className="feature-small-article"
                        key={article.id}
                      >
                        <Container>
                          <ArticleCardWrapper
                            article={article}
                            dataEventCategoryForCategory="Tool Category Title"
                            dataEventActionForCategory="Click"
                            dataEventLabelForCategory={`https://${domainLocales[sL]}${article.category.permalink}`}
                            dataEventCategoryForTitle="Tool Title"
                            dataEventActionForTitle="Click"
                            dataEventLabelForTitle={`https://${domainLocales[sL]}${article.permalink}`}
                            dataEventCategoryForBanner="Tools Image"
                            dataEventActionForBanner="Click"
                            dataEventLabelForBanner={`https://${domainLocales[sL]}${article.permalink}`}
                            type="author"
                            size="md"
                            banner={
                              <ImageWrap
                                src={
                                  article.featureImageMobileXs ||
                                  article.featureImage ||
                                  DEFAULT_IMG
                                }
                                loading="lazy"
                                alt={article.postTitle || article.postName}
                              />
                            }
                            articleLink={article.permalink}
                            categoryLink={article.category.permalink}
                            categoryName={article.category?.displayName}
                            styleLabel={{
                              color: article.category.textColor,
                            }}
                            isMobile={isMobile}
                            specialty={article.expert?.specialty}
                            title={article.postTitle || article.postName}
                            text=""
                            avatarImgRenderer={(avatar, name) => (
                              <ImageWrap
                                src={avatar}
                                loading="lazy"
                                style={{ width: '100%', height: '100%' }}
                                alt={name}
                              />
                            )}
                            uploadTime={article.modifiedTime}
                            headingType="h5"
                          />
                        </Container>
                      </StyledFeatureSmallArticleContainer>
                    ))}
                  </StyledArticlesContainer>
                </>
              )}
              {!hideUIElements && (
                <Link href={seeMoreLink || '/'}>
                  <a
                    data-event-category="Categories Dropdown"
                    data-event-action="Click See More"
                    data-event-label={`https://${domainLocales[sL]}/expert`}
                    style={{ textDecoration: 'none' }}
                  >
                    <StyledFeatureTopicSeeMore>
                      <Heading tag="h5" color={theme.colors.primaryBase}>
                        {f({
                          id: 'home.seeMore',
                          defaultMessage: 'See More',
                        })}
                      </Heading>
                      <ImageWrap
                        src={'/images/chevronRightBlue.svg'}
                        style={{ width: '16px', height: '16px' }}
                        alt={f({
                          id: 'home.seeMore',
                          defaultMessage: 'See More',
                        })}
                      />
                    </StyledFeatureTopicSeeMore>
                  </a>
                </Link>
              )}
            </StyledContainer>
          )}
        </StyleFeaturedTopics>
      ) : (
        <StyleFeaturedTopics data-is-expert-page={hideUIElements || undefined}>
          {/* desktop-heading */}
          {!hideUIElements && (
            <StyledHeaderContainer>
              <Heading tag="h4" color={theme.colors.gray800}>
                {f({
                  id: 'tools.suggestedArticles',
                  defaultMessage: 'Suggested Articles',
                })}
              </Heading>
              <Link href={seeMoreLink || '/'}>
                <a
                  data-event-category="Categories Dropdown"
                  data-event-action="Click See More"
                  data-event-label={`https://${domainLocales[sL]}/expert`}
                  style={{ textDecoration: 'none' }}
                >
                  <StyledFeatureTopicSeeMore>
                    <Heading tag="h5" color={theme.colors.primaryBase}>
                      {f({
                        id: 'home.seeMore',
                        defaultMessage: 'See More',
                      })}
                    </Heading>
                    <ImageWrap
                      src={'/images/chevronRightBlue.svg'}
                      style={{ width: '16px', height: '16px' }}
                      alt={f({
                        id: 'home.seeMore',
                        defaultMessage: 'See More',
                      })}
                    />
                  </StyledFeatureTopicSeeMore>
                </a>
              </Link>
            </StyledHeaderContainer>
          )}

          {/* desktop-articles */}
          <StyledArticlesDesktopContainer>
            {isLoading ? (
              <ArticlesSkeleton />
            ) : (
              articles &&
              articles.length > 0 && (
                <>
                  <StyledHeroContainer key={articles[0].id}>
                    <ArticleCardWrapper
                      dataEventCategoryForCategory="Tool Category Title"
                      dataEventActionForCategory="Click"
                      dataEventLabelForCategory={`https://${domainLocales[sL]}${articles[0].category.permalink}`}
                      dataEventCategoryForTitle="Tool Title"
                      dataEventActionForTitle="Click"
                      dataEventLabelForTitle={`https://${domainLocales[sL]}${articles[0].permalink}`}
                      dataEventCategoryForBanner="Tool Image"
                      dataEventActionForBanner="Click"
                      dataEventLabelForBanner={`https://${domainLocales[sL]}${articles[0].permalink}`}
                      type="author"
                      size="lg"
                      direction="vertical"
                      banner={
                        <ImageWrap
                          data-event-category="Tool Image"
                          data-event-action="Click"
                          data-event-label={`https://${domainLocales[sL]}${articles[0].permalink}`}
                          src={
                            articles[0].featureImage ||
                            articles[0].featureImageMobile ||
                            DEFAULT_IMG
                          }
                          alt={articles[0].postTitle}
                          loading="lazy"
                        />
                      }
                      specialty={articles[0].expert?.specialty}
                      isMobile={isMobile}
                      article={articles[0]}
                      articleLink={articles[0].permalink}
                      categoryLink={articles[0].category.permalink}
                      categoryName={articles[0].category?.displayName}
                      title={articles[0].postTitle || articles[0].postName}
                      text={''}
                      avatarImgRenderer={(avatar, name) => (
                        <ImageWrap
                          src={avatar}
                          loading="lazy"
                          style={{ width: '100%', height: '100%' }}
                          alt={name}
                        />
                      )}
                      uploadTime={articles[0].modifiedTime}
                      styleLabel={{
                        fontSize: theme.sizes.fsHeading6,
                        color: articles[0].category.textColor,
                      }}
                    />
                  </StyledHeroContainer>
                  <StyledSubColumnContainer>
                    {articles.slice(1, 3).map((article: Article) => (
                      <StyledSmallArticleDesktopContainer key={article.id}>
                        <ArticleCardWrapper
                          dataEventCategoryForCategory="Tool Category Title"
                          dataEventActionForCategory="Click"
                          dataEventLabelForCategory={`https://${domainLocales[sL]}${article.category.permalink}`}
                          dataEventCategoryForTitle="Tool Title"
                          dataEventActionForTitle="Click"
                          dataEventLabelForTitle={`https://${domainLocales[sL]}${article.permalink}`}
                          dataEventCategoryForBanner="Tool Image"
                          dataEventActionForBanner="Click"
                          dataEventLabelForBanner={`https://${domainLocales[sL]}${article.permalink}`}
                          type="author"
                          size="sm"
                          direction="vertical"
                          banner={
                            <ImageWrap
                              data-event-category="Tool Image"
                              data-event-action="Click"
                              data-event-label={`https://${domainLocales[sL]}${article.permalink}`}
                              src={
                                article.featureImageMobile ||
                                article.featureImage ||
                                DEFAULT_IMG
                              }
                              loading="lazy"
                              alt={article.postTitle}
                            />
                          }
                          articleLink={article.permalink}
                          article={article}
                          categoryLink={article.category.permalink}
                          categoryName={article.category?.displayName}
                          isMobile={isMobile}
                          specialty={article.expert?.specialty}
                          title={article.postTitle || article.postName}
                          text={''}
                          avatarImgRenderer={(avatar, name) => (
                            <ImageWrap
                              src={avatar}
                              style={{ width: '100%', height: '100%' }}
                              alt={name}
                              loading="lazy"
                            />
                          )}
                          uploadTime={article.modifiedTime}
                          className="desktop-article"
                          styleLabel={{
                            fontSize: theme.sizes.fsCaption2,
                            color: article.category.textColor,
                          }}
                        />
                      </StyledSmallArticleDesktopContainer>
                    ))}
                  </StyledSubColumnContainer>
                </>
              )
            )}
          </StyledArticlesDesktopContainer>
        </StyleFeaturedTopics>
      )}
    </>
  )
}

export { ToolsSuggestionArticles }
